<div class="timesheet-manual-form-wrapper">
  <!-- form -->
  <form [formGroup]="form" class="timesheet-manual-form" *ngIf="form">
    <!-- employee -->
    <app-form-input-text [field]="'employee'" [formControl]="f['employee']" formControlName="employee"
      *ngIf="employee"></app-form-input-text>
    <div>
      <!-- type -->
      <app-form-input-dropdown [options]="timesheetRecordOptions" [optionsField]="'name'" [noLabel]="false" [appendTo]="'body'" [clearable]="false"
        [filter]="false" [field]="'timesheet-type'" [formControl]="f['type']" formControlName="type"></app-form-input-dropdown>
      <!-- day -->
      <app-form-input-date [field]="'day'" [formControl]="f['day']" formControlName="day"
        [maxDate]="today"></app-form-input-date>
    </div>
    <div class="recordHours">
      <!-- recordBegin -->
      <app-form-input-date [field]="'recordBegin'" [formControl]="f['recordBegin']" formControlName="recordBegin"
        [timeOnly]="true" [stepMinute]="1" [maxDate]="maxTime"></app-form-input-date>
      <!-- recordEnd -->
      <app-form-input-date [field]="'recordEnd'" [formControl]="f['recordEnd']" formControlName="recordEnd"
        [timeOnly]="true" [stepMinute]="1" [maxDate]="maxTime"></app-form-input-date>
      <app-form-input-error *ngIf="form.touched && form.errors?.['atLeastOneRequired']" [show]="true"
        [requiredOne]="form.errors?.['atLeastOneRequired']"></app-form-input-error>
    </div>
    <!-- comments -->
    <app-form-input-editor [field]="'comments'" [formControl]="f['comments']"
      [formControlName]="'comments'" [height]="'10vh'"></app-form-input-editor>
  </form>
  <!-- buttons -->
  <div class="buttons">
    <p-button [label]="'button.cancel' | translate" severity="secondary" (click)="cancel()"/>
    <p-button [label]="'button.save' | translate" severity="contrast" (click)="save()"/>
  </div>
</div>